export const openEmail = (email: string, subject?: string) => {
  const subjectParam = subject ? `?subject=${encodeURIComponent(subject)}` : ''
  window.location.href = `mailto:${email}${subjectParam}`
}

